






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { IPlaylistContainer } from './index.vue'
import { PLAYLIST_TYPES } from '@/classes/playlist'

@Component({})
export default class Row extends Vue {
  @Prop({
    required: true
  })
  data: IPlaylistContainer

  @Prop({
    required: true
  })
  allowDrag: boolean

  toggleSelected(e: MouseEvent) {
    if (this.allowDrag) return

    this.data.selected = !this.data.selected

    this.$emit('selected', this.data, e.shiftKey)
  }

  toggleCollapsed() {
    this.data.collapsed = !this.data.collapsed

    this.$emit('collapse', this.data, this.data.collapsed)
  }

  get label(): string {
    let s = this.data.playlist.name

    if (this.data.playlist.type === PLAYLIST_TYPES.Playlist) s += ` (${this.data.playlist.tracks.length})`

    return s
  }

  get indentLevel(): number {
    let level: number = -1

    let parent = this.data.parent

    while (parent) {
      level++

      parent = parent.parent
    }

    return level
  }
}
